import { ReactNode, useCallback } from 'react'

import { SidebarItem, useLayoutContext } from '@/lib/core/components/Layout'

import styles from './SidebarNav.module.css'
import { useNavItems } from './useNavItems'

const SUBBIE_UPGRADE_MESSAGE = 'Upgrade your plan to access'
const BLOCKED_ICON_COLOR = '#A19F9C'

export const SidebarNav = () => {
  const { isMenuExpanded } = useLayoutContext()
  const { visibleItems } = useNavItems()

  const renderMessage = useCallback(
    (message: ReactNode) => isMenuExpanded && message,
    [isMenuExpanded],
  )

  return (
    <nav className={styles.sidebarNav}>
      <ul className={styles.sidebarList}>
        {visibleItems.map(({ id, label, href, Icon, isBlocked }) =>
          isBlocked ? (
            <li key={id} title={SUBBIE_UPGRADE_MESSAGE} style={{ cursor: 'not-allowed' }}>
              <div className={styles.sidebarItem}>
                <Icon size="24" color={BLOCKED_ICON_COLOR} />
                {renderMessage(
                  <div className={styles.subbieUpgrade}>
                    <div>{label}</div>
                    <div className={styles.subbieSubLine}>{SUBBIE_UPGRADE_MESSAGE}</div>
                  </div>,
                )}
              </div>
            </li>
          ) : (
            <SidebarItem key={id} href={href}>
              <div className={styles.sidebarItem}>
                <Icon size="24" />
                {renderMessage(label)}
              </div>
            </SidebarItem>
          ),
        )}
      </ul>
    </nav>
  )
}
